import { ApiClient } from '@glomopay/utils';

import { env } from '@/config/env';

const THIRTY_SECONDS_IN_MS = 30_000;

export const publicApiClient = new ApiClient({
  baseURL: `${env.VITE_API_BASE_URL}/public`,
  timeout: THIRTY_SECONDS_IN_MS,
  withCredentials: true,
  enableCaseConversion: true,
});
